import { ref } from 'vue'
/**
 * 当前token使用的key
 */
const tokenLocalKey = 'token'
/**
 * 当前使用token
 */
export let token = ref('')
/**
 * 获取token
 */
export const getToken = function () {
  let localToken = import.meta.env.PROD ? localStorage.getItem(tokenLocalKey) : localStorage.getItem('_token')
  if (localToken) token.value = localToken
  return token.value
}
/**
 * 设置token
 */
export const setToken = function (newToken) {
  token.value = newToken
  localStorage.setItem(tokenLocalKey, newToken)
}
/**
 * 删除token
 */
export function removeToken() {
  token.value = ''
  return localStorage.removeItem(tokenLocalKey)
}